import React, { useCallback, useEffect, useState, useContext } from 'react';
import { IconButton } from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { Dialog } from '@mui/material';
import AuthContext from "../../../../context/auth-context"
import axios from 'axios'
import { mapDocumentTemplateTypeName, mapFlagName, mapSemanticNegativeValue } from './signer_analysis_utils';

function SignerAnalysisDataDialog(props) {

    const {
        open,
        setOpen,
        signerAnalyzing,
        setSignerAnalyzing,
    } = props

    const statesToInitial = useCallback(() => {
        setSignerAnalyzing(undefined)
    }, [setSignerAnalyzing])

    const onCloseDialog = useCallback(() => {
        statesToInitial()
        setOpen(false)
    }, [statesToInitial, setOpen])

    const [dialogSize, setDialogSize] = useState("lg")
    const [faceReconImageUrl, setFaceReconImageUrl] = useState(null)
    const [ocrImagesUrls, setOcrImagesUrls] = useState(null)
    const [hasAttachments, SetHasAttachments] = useState(false)
    const userRoles = useContext(AuthContext).user_data.roles

    const fetchFaceReconImage = useCallback(() => {
        const timer = setTimeout(() => {
            axios.get(`/dash/sign/signer/${signerAnalyzing.signer_key}/face_recognition`)
                .then((response) => {
                    setFaceReconImageUrl(response.data.url)
                    setDialogSize("lg")
                    SetHasAttachments(true)
                })
                .catch((error) => {
                })
                .finally(() => {
                })
        }, 500)
        return () => {
            clearTimeout(timer)
        }
    }, [signerAnalyzing.signer_key])

    const fetchOCRUrls = useCallback(() => {
        const timer = setTimeout(() => {
            axios.get(`/dash/sign/signer/${signerAnalyzing.signer_key}/ocr`)
                .then((response) => {
                    setOcrImagesUrls(response.data.urls)
                    setDialogSize("lg")
                    SetHasAttachments(true)
                })
                .catch((error) => {
                })
                .finally(() => {
                })
        }, 500)
        return () => {
            clearTimeout(timer)
        }
    }, [signerAnalyzing.signer_key])

    useEffect(() => {
        if (userRoles.includes("read_signer_images")) {
            if (signerAnalyzing.signer_analysis?.liveness) {
                fetchFaceReconImage()
            }
            if (signerAnalyzing.signer_analysis?.facematch_document) {
                fetchOCRUrls()
            }
        }
    }, [userRoles, fetchFaceReconImage, fetchOCRUrls, signerAnalyzing])

    const hasNegativeValues = (document_data) => {
        return Object.entries(document_data || {}).some(
            ([flag, value]) => mapSemanticNegativeValue(flag) === value
        );
    }


    return (
        <Dialog
            open={open}
            onClose={() => onCloseDialog()}
            fullWidth
            maxWidth={dialogSize}
        >

            {
                signerAnalyzing.signer_analysis
                    ?
                    <div className="dialog__column-container">
                        <header style={{ marginBottom: '10px' }}>
                            <h1 style={{ fontSize: '22px', color: "#0b1f82" }}>Dados de assinatura</h1>
                            <IconButton
                                onClick={() => onCloseDialog()}
                            >
                                <CloseIcon />
                            </IconButton>
                        </header>
                        <div style={{ marginBottom: '20px' }}>
                            <p>
                                <span style={{ fontSize: '16px' }}><strong>Nome:</strong></span>
                                <span style={{ fontSize: '16px', marginLeft: '10px' }}>{signerAnalyzing.name}</span>
                            </p>
                        </div>
                        <div className='inbox__body_d_block'>
                            {
                                signerAnalyzing.signer_analysis?.liveness &&
                                <div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
                                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', width: '80%' }}>
                                            <span style={{ fontSize: '16px', color: "#0b1f82" }}>
                                                <strong>Liveness</strong>
                                            </span>
                                            <p style={{ fontSize: '14px', marginTop: '5px' }}>
                                                O rosto foi validado na análise de liveness?
                                            </p>
                                        </div>
                                        {
                                            signerAnalyzing.signer_analysis?.liveness?.status === 'live' &&
                                            <div style={{
                                                padding: '10px',
                                                fontSize: '14px',
                                                color: 'green',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}>
                                                OK
                                            </div>
                                        }
                                        {
                                            signerAnalyzing.signer_analysis?.liveness?.status !== 'live' &&
                                            <div style={{
                                                padding: '10px',
                                                fontSize: '14px',
                                                color: 'red',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}>
                                                Não
                                            </div>
                                        }

                                    </div>
                                    {
                                        signerAnalyzing.signer_analysis?.liveness.flags &&
                                        <div style={{ marginBottom: '20px' }}>
                                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', width: '80%' }}>
                                                <span style={{ fontSize: '16px', color: "#0b1f82" }}>
                                                    <strong>Liveness - Indicadores</strong>
                                                </span>
                                                <p style={{ fontSize: '14px', marginTop: '5px' }}>
                                                    Indicadores detectados durante a sessão de liveness:
                                                </p>
                                                {
                                                    hasNegativeValues(signerAnalyzing.signer_analysis?.liveness?.flags) ?
                                                        (
                                                            <ul style={{ fontSize: '14px', marginTop: '10px', marginLeft: '40px' }}>
                                                                {Object.entries(signerAnalyzing.signer_analysis?.liveness?.flags || {}).map(([flag, value]) =>
                                                                    mapFlagName(flag) && mapSemanticNegativeValue(flag) === value && (
                                                                        <li style={{ marginBottom: '5px' }} key={flag}>
                                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                                                <span>{mapFlagName(flag)}</span>
                                                                                <ErrorOutlineIcon style={{ color: 'red' }} />
                                                                            </div>
                                                                        </li>
                                                                    )
                                                                )}
                                                            </ul>
                                                        ) : <div style={{ display: 'flex', alignItems: 'center', gap: '5px', marginTop: '10px' }}>
                                                            <p style={{ fontSize: '14px'}}>
                                                                Nennhum indicador negativo detectado
                                                            </p>
                                                            <CheckCircleOutlineIcon style={{ color: 'green' }} />
                                                        </div>
                                                }
                                            </div>
                                        </div>
                                    }
                                </div>
                            }

                            {
                                (signerAnalyzing.ocr || []).length > 0 &&
                                <div style={{ marginBottom: '20px' }}>
                                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', width: '80%' }}>
                                        <span style={{ fontSize: '16px', color: "#0b1f82" }}>
                                            <strong>OCR - Indicadores</strong>
                                        </span>
                                        <p style={{ fontSize: '14px', marginTop: '5px' }}>
                                            Indicadores detectados no processo de OCR de documento:
                                        </p>
                                        {
                                            (signerAnalyzing.ocr || []).filter(document => document.document_data)
                                                .map(document => (

                                                    <div style={{ marginLeft: '10px', marginTop: '10px' }}>
                                                        <span style={{ fontSize: '14px' }}>
                                                            <strong>{mapDocumentTemplateTypeName(document.template_type)}</strong>
                                                        </span>
                                                        {
                                                            hasNegativeValues(document.document_data)
                                                                ?
                                                                <ul style={{ fontSize: '14px', marginTop: '5px', marginLeft: '30px' }}>
                                                                    {Object.entries(document.document_data || {}).map(([flag, value]) =>
                                                                        mapFlagName(flag) && mapSemanticNegativeValue(flag) === value && (
                                                                            <li style={{ marginBottom: '5px' }} key={flag}>
                                                                                <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                                                    <span>{mapFlagName(flag)}</span>
                                                                                    <ErrorOutlineIcon style={{ color: 'red' }} />
                                                                                </div>
                                                                            </li>
                                                                        )
                                                                    )}
                                                                </ul> : <div style={{ display: 'flex', alignItems: 'center', gap: '5px', marginTop: '10px'  }}>
                                                                    <p style={{ fontSize: '14px'}}>
                                                                        Nennhum indicador negativo detectado
                                                                    </p>
                                                                    <CheckCircleOutlineIcon style={{ color: 'green' }} />
                                                                </div>
                                                        }
                                                    </div>
                                                ))
                                        }
                                    </div>
                                </div>
                            }

                            {
                                signerAnalyzing.signer_analysis?.facematch_document &&
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
                                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', width: '80%' }}>
                                        <span style={{ fontSize: '16px', color: "#0b1f82" }}>
                                            <strong>Face Match de Documento</strong>
                                        </span>
                                        <p style={{ fontSize: '14px', marginTop: '5px' }}>
                                            A foto do documento bate com a foto do bureau de validação de face?
                                        </p>
                                    </div>
                                    <div style={{
                                        padding: '10px',
                                        fontSize: '14px',
                                        color: 'blue',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                        {signerAnalyzing.signer_analysis?.facematch_document?.similarity_ratio}%
                                    </div>
                                </div>
                            }

                            {
                                (signerAnalyzing.signer_analysis?.registration?.face_validation_data || []).length > 0 &&
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
                                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', width: '80%' }}>
                                        <span style={{ fontSize: '16px', color: "#0b1f82" }}>
                                            <strong>Validação de Faces</strong>
                                        </span>
                                        <p style={{ fontSize: '14px', marginTop: '5px' }}>
                                            A foto do rosto confere com o CPF informado?
                                        </p>
                                    </div>
                                    <div style={{
                                        padding: '10px',
                                        fontSize: '14px',
                                        color: 'blue',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                        {signerAnalyzing.signer_analysis?.registration?.face_validation_data[0].score}%
                                    </div>
                                </div>
                            }

                            {
                                signerAnalyzing.signer_analysis?.registration?.fraud_face_matches &&
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
                                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', width: '80%' }}>
                                        <span style={{ fontSize: '16px', color: "#0b1f82" }}>
                                            <strong>Validação de Fraude</strong>
                                        </span>
                                        <p style={{ fontSize: '14px', marginTop: '5px' }}>
                                            O rosto foi encontrado na base de fraudadores?
                                        </p>
                                    </div>
                                    {
                                        signerAnalyzing.signer_analysis?.registration?.fraud_face_matches?.length > 0 &&
                                        <div style={{
                                            padding: '10px',
                                            fontSize: '14px',
                                            color: 'red',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}>
                                            Sim
                                        </div>
                                    }
                                    {
                                        signerAnalyzing.signer_analysis?.registration?.fraud_face_matches?.length === 0 &&
                                        <div style={{
                                            padding: '10px',
                                            fontSize: '14px',
                                            color: 'green',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}>
                                            Não
                                        </div>
                                    }
                                </div>
                            }
                            {
                                userRoles.includes("read_signer_images") && hasAttachments
                                && <div style={{ marginTop: '40px', marginBottom: '20px', textAlign: 'center' }}>
                                    <span style={{ fontSize: '16px', color: "#0b1f82" }}>
                                        <strong>Anexos do assinante</strong>
                                    </span>
                                    {
                                        faceReconImageUrl &&
                                        <div style={{ marginTop: '20px', marginBottom: '20px', textAlign: 'center' }}>
                                            <img
                                                style={{ margin: "10px auto auto auto", borderRadius: "5px" }}
                                                src={faceReconImageUrl}
                                                alt="face_recognition_image"
                                            />
                                        </div>

                                    }
                                    {
                                        ocrImagesUrls &&
                                        <div style={{ marginTop: '40px', marginBottom: '20px', textAlign: 'center' }}>
                                            {
                                                ocrImagesUrls.map((imgUrl) => (
                                                    <img
                                                        style={{ margin: "10px auto auto auto", borderRadius: "5px" }}
                                                        src={imgUrl}
                                                        alt="ocr_image_url"
                                                    />
                                                ))
                                            }
                                        </div>
                                    }
                                </div>
                            }

                        </div>
                    </div>
                    : <div className="dialog__column-container">
                        <header style={{ marginBottom: '10px' }}>
                            <h1 style={{ fontSize: '22px' }}>Dados de assinatura</h1>
                            <IconButton
                                onClick={() => onCloseDialog()}
                            >
                                <CloseIcon />
                            </IconButton>
                        </header>
                        <div style={{ marginBottom: '20px' }}>
                            <p>
                                <span style={{ fontSize: '16px' }}><strong>Nome:</strong></span>
                                <span style={{ fontSize: '16px', marginLeft: '10px' }}>{signerAnalyzing.name}</span>
                            </p>
                        </div>
                        <div className='inbox__body_d_block'>
                            <span className="signer-data-dialog__error error-message">
                                Não foi possível obter os dados de assinatura
                            </span>
                        </div>
                    </div>

            }
        </Dialog>
    );
}

export default SignerAnalysisDataDialog;